<template>
  <div
    :class="{ 'form-popup-overlay': true, 'is-visible': isVisible, 'px-5': true }"
    @click="hide">
    <div
      :class="{ 'form-popup': true, 'px-5': true, 'pb-4': true, 'pt-4': true, 'is-loading': loading }"
      @click.stop>
      <h3 class="text-center">
        {{ popupTitle }}
      </h3>

      <validation-observer ref="checklist-item-form" tag="form">
        <d-row>
          <div class="form-group w-100">
            <validation-provider
              rules="required"
              name="name"
              v-slot="{ errors }">
              <label for="name">Item name:</label>
              <d-input
                v-model="data.name"
                :state="errors.length ? 'invalid' : null" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
        </d-row>

        <d-row
          v-if="data.reference_type === 'AIRPORT'">
          <label class="d-block">
            Handler type:
          </label>
        </d-row>

        <d-row
          v-if="data.reference_type === 'AIRPORT'"
          class="mb-2">
          <d-form-radio
            v-model="data.handler_type"
            inline
            name="handler_type"
            :value="null">
            None
          </d-form-radio>
          <d-form-radio
            v-model="data.handler_type"
            inline
            name="handler_type"
            value="DEPARTURE">
            Departure
          </d-form-radio>
          <d-form-radio
            v-model="data.handler_type"
            inline
            name="handler_type"
            value="ARRIVAL">
            Arrival
          </d-form-radio>
        </d-row>
      </validation-observer>

      <d-row>
        <div class="text-center w-100">
          <d-button
            @click.prevent="validateForm"
            theme="success"
            class="mr-5">
            Save
          </d-button>

          <d-button
            @click.prevent="cancel"
            outline
            theme="secondary">
            Cancel
          </d-button>
        </div>
      </d-row>
    </div>
  </div>
</template>

<script>
import FormUtils from './../../utils/FormUtils';

export default {
  name: 'ChecklistItemPopup',
  computed: {
    popupTitle () {
      if (this.mode === 'add') {
        return 'Add checklist item';
      }

      return 'Edit checklist item';
    }
  },
  data () {
    return {
      isVisible: false,
      mode: 'add',
      loading: false,
      data: {
        id: false,
        name: '',
        handler_type: null,
        ordering: null,
        reference_type: null,
        reference_id: null
      }
    };
  },
  mounted () {
    this.$bus.$on('show-checklist-item-popup', this.show);
  },
  methods: {
    show (mode, referenceType = false, referenceId = false, itemId = false) {
      this.mode = mode;

      if (mode === 'add') {
        this.loading = false;
        this.data = {
          id: false,
          name: '',
          handler_type: null,
          ordering: null,
          check_list_id: null,
          reference_type: referenceType,
          reference_id: referenceId
        };
      } else {
        this.loading = true;
        this.data.reference_type = referenceType;
        this.data.reference_id = referenceId;
        this.loadChecklistData(itemId);
      }

      setTimeout(() => {
        this.$refs['checklist-item-form'].reset();
        this.isVisible = true;
      }, 100);
    },
    loadChecklistData (itemId) {
      let endpointURL = '/check-lists/item/';
      let fieldsToLoad = ['id', 'name', 'ordering', 'reference_type', 'reference_id', 'handler_type'];

      if (this.data.reference_type === 'CHECKLIST') {
        endpointURL = '/check-list-templates/items/item/';
        fieldsToLoad = ['id', 'name', 'ordering', 'check_list_id'];
      }

      FormUtils.loadItemData(this, {
        id: itemId,
        endpointBase: endpointURL,
        instanceFields: fieldsToLoad,
        loadedKey: 'loaded',
        successAction: () => {
          this.loading = false;

          if (this.data.check_list_id) {
            this.data.reference_id = this.data.check_list_id;
          }
        },
        failAction: () => {
          this.loading = false;
        }
      });
    },
    validateForm () {
      FormUtils.validate(this.$refs['checklist-item-form'], this.submitForm);
    },
    submitForm () {
      this.loading = true;
      let endpointUrl = '/check-lists/store';

      if (this.mode === 'edit') {
        endpointUrl = '/check-lists/update/' + this.data.id;
      }

      if (this.data.reference_type === 'CHECKLIST') {
        endpointUrl = '/check-list-templates/items/store';

        if (this.mode === 'edit') {
          endpointUrl = '/check-list-templates/items/update/' + this.data.id;
        }
      }

      let formDataToSend = this.prepareFormData();

      FormUtils.submit({
        $http: this.$http,
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: this.mode === 'add' ? 'Item added' : 'Item saved',
        successText: '',
        errorTitle: 'An error occurred',
        errorText: 'The system was unable to save the item. Please try again.',
        successAction: () => {
          this.loading = false;
          this.isVisible = false;

          if (this.data.reference_type === 'CHECKLIST') {
            this.$bus.$emit('checklist-template-items-list-reload');
          } else {
            this.$bus.$emit('checklist-list-reload');
          }
        },
        failAction: () => {
          this.loading = false;
          this.isVisible = false;
        }
      });
    },
    cancel () {
      this.isVisible = false;
      this.loading = false;
    },
    hide () {
      this.isVisible = false;
      this.loading = false;
    },
    prepareFormData () {
      let dataToSend = {
        name: this.data.name,
        ordering: this.data.ordering
      };

      if (this.data.reference_type !== 'CHECKLIST') {
        dataToSend.reference_type = this.data.reference_type;
        dataToSend.reference_id = this.data.reference_id;
      } else {
        dataToSend.check_list_id = this.data.reference_id;
      }

      if (this.data.reference_type === 'AIRPORT') {
        dataToSend.handler_type = this.data.handler_type;
      }

      return dataToSend;
    }
  },
  beforeDestroy () {
    this.$bus.$off('show-checklist-item-popup', this.show);
  }
}
</script>
